import * as React from "react";

import { Box, makeStyles, Theme, Typography } from "@material-ui/core";

import {
  UIFieldMap,
  useLead,
  useMerchantModel,
  useTranslation,
  useUiFieldMap,
} from "client/hooks";
import { MerchantFieldMapper } from "client/lib/apt-merchant";

import { FormBuilder } from "../FormBuilder";
import { YesOrNoQuestionsHeader } from "../YesOrNoQuestionsHeader";

const useStyles = makeStyles((theme: Theme) => ({
  heading: {
    fontWeight: theme.typography.fontWeightBold,
    fontSize: `${32 / 16}rem`,
  },
}));
export type LeadFormFieldUiMap = MerchantFieldMapper<UIFieldMap>;

// field order reflects input order
const uiFieldMap: LeadFormFieldUiMap = {
  lead: {
    firstName: {},
    lastName: {},
    registeredCountry: {},
    industry: {},
    subIndustry: {},
    phone: { width: 12 },
    salesChannel: { width: 12 },
    contactlessPayment: { width: 12 },
    storeName: {},
    website: {},
    platform: { width: 12 },
    acquirer: { width: 12 },
    numOfStores: { width: 12 },
    totalAnnualSales: { width: 12 },
    totalAnnualSalesInStore: { width: 12 },
    email: {},
    // YES/NO risk questions
    franchisee: { width: 12, customFieldHeader: <YesOrNoQuestionsHeader /> },
    franchiseName: { width: 12 },
  },
};

export const LeadForm: React.FC<{
  displayHeader?: boolean;
  fieldMap?: LeadFormFieldUiMap;
}> = ({ displayHeader = true, fieldMap = uiFieldMap }) => {
  const classes = useStyles();
  const t = useTranslation();

  const { orderedUiFieldMap } = useUiFieldMap(fieldMap);

  const { merchant } = useMerchantModel();

  const { handleSubmit } = useLead();

  return (
    <Box pt={4} pl={4} pr={4}>
      {displayHeader && (
        <Box mb={4}>
          <Typography variant="h5" className={classes.heading}>
            {t("uiLeadFormHeading")}
          </Typography>
          <Box mt={1}>
            <Typography variant="body2">{t("uiLeadFormSubHeader")}</Typography>
          </Box>
        </Box>
      )}
      <Box alignItems="center">
        <FormBuilder
          fieldSet={merchant.lead}
          footer={
            <>
              {merchant.companyInformation.registeredCountry.value ===
                "United Kingdom" && (
                <Box mt={3}>
                  <Typography variant="body2">
                    Our{" "}
                    <a
                      href="https://www.clearpay.co.uk/en-GB/merchant-privacy"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      privacy policy
                    </a>{" "}
                    contains information about how we use the data you give us
                    and your legal rights. By continuing, you confirm you have
                    read our policy.
                  </Typography>
                </Box>
              )}
            </>
          }
          onSubmit={handleSubmit}
          uiFieldMap={orderedUiFieldMap.lead}
        />
      </Box>
    </Box>
  );
};
